// SHER-1055 — when a treatment submission was stopped, whichever shape the patient file
// holds it in. The clinical-history list holds SLIM rows: the API carries the stop on
// `treatmentStoppedAt` (getPatientSubmissionsSlim). After a stop succeeds, or once the
// detail was loaded, the store holds the FULL submission: the stop lives inside the
// treatment record's value, one entry per medication for an outpatient prescription, a
// single object for an inpatient treatment. One reader, so the table's stop action, the
// row marker and the edit pencil cannot disagree about the same ordonnance.

const TREATMENT_FIELD_TYPES = ['treatment_prescription', 'treatment_inpatient'];

// A stop timestamp is an ISO string (API) or an epoch-ms string (offline optimistic
// write). '' and 'NaN' mean live, as the medication table already reads them
// (SmartFields/index.tsx, FillSurvey.treatments.ts).
function asStoppedAt(value: any): string | null {
    if (typeof value === 'number' && Number.isFinite(value)) {
        return String(value);
    }
    if (typeof value === 'string' && value !== '' && value !== 'NaN') {
        return value;
    }
    return null;
}

function stoppedAtOfValue(value: any): string | null {
    const entries = Array.isArray(value) ? value : [value];
    for (const entry of entries) {
        const stoppedAt = asStoppedAt(entry?.['treatment-stoppedAt']);
        if (stoppedAt) {
            return stoppedAt;
        }
    }
    return null;
}

export function treatmentStoppedAtOf(submission: any): string | null {
    if (!submission) {
        return null;
    }
    const slimStoppedAt = asStoppedAt(submission.treatmentStoppedAt);
    if (slimStoppedAt) {
        return slimStoppedAt;
    }
    for (const record of submission.surveyRecords || []) {
        if (TREATMENT_FIELD_TYPES.includes(record?.surveyField?.type)) {
            const stoppedAt = stoppedAtOfValue(record.value);
            if (stoppedAt) {
                return stoppedAt;
            }
        }
    }
    return null;
}
